import { FullScreenCenter } from "./LoadingScreen";
import { Box } from "@twilio-paste/core";
import { Button } from "@twilio-paste/button";

type SignedOutScreenProps = {
  onLogin: () => void | Promise<void>;
};

export const SignedOutScreen = ({ onLogin }: SignedOutScreenProps) => (
  <FullScreenCenter>
    <Box
      as="section"
      padding="space80"
      borderRadius="borderRadius30"
      boxShadow="shadow"
      maxWidth="size60"
      textAlign="center"
    >
      <Box as="h2" marginBottom="space50">
        Sei disconnesso.
      </Box>
      <Box marginBottom="space40">Vuoi autenticarti di nuovo?</Box>
      <Button variant="primary" onClick={onLogin}>
        Accedi
      </Button>
    </Box>
  </FullScreenCenter>
);
